import Layout from '@/components/layout/Layout.vue'
import { deleteLoginDevices, getLoginDevices } from '@/api/login-device'

export default {
    components: {
        Layout,
    },
    props: {
        showOnlinePage: {
            type: Boolean,
            required: true
        },
        model: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            data: [],
            pagination: {
                defaultPageSize: 20,
                showSizeChanger: true,
                onShowSizeChange: this.pageSizeChange,
                pageSizeOptions: ['10', '20', '30', '40', '60', '80', '100'],
                showTotal: (total) => {
                    return ' 共 ' + total + ' 条'
                },
            },
            loading: false,
            selectedRowKeys: [],
            columns: [
                { width: 120, title: '钉钉昵称', dataIndex: 'nick' },
                { width: 140, title: 'IP地址', dataIndex: 'ip' },
                { width: 120, title: 'IP归属', dataIndex: 'region', ellipsis: true },
                { width: 180, title: '登录时间', dataIndex: 'created_at' },
                { width: 180, title: '过期时间', dataIndex: 'expired_at' },
                { title: '代理信息', dataIndex: 'user_agent', ellipsis: true },
            ],
            showForm: false,
            queryParam: {},
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        destroy(record) {
            const del = ids => {
                deleteLoginDevices(ids).then(res => {
                    this.$message.destroy()
                    if (res && res.code === 0) {
                        this.$message.success('删除成功')
                        this.refresh()
                    }
                })
            }
            if (!record) {
                return this.$confirm({
                    title: '操作提示',
                    centered: true,
                    content: () => <div
                        style="color:red;">确定要删除选中的 {this.selectedRowKeys.length} 条数据吗?</div>,
                    onOk: () => {
                        del(this.selectedRowKeys)
                    }
                })
            }
            del([record.id])
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys
        },
        handleTableChange(pagination) {
            const pager = {...this.pagination}
            pager.current = pagination.current
            this.pagination = pager
            this.getData()
        },
        getData() {
            this.loading = true
            const pagination = {...this.pagination}
            const json = Object.assign({}, this.queryParam, {
                admin_id: this.model.id,
                page: pagination.current,
                page_size: pagination.defaultPageSize,
            })
            getLoginDevices(json).then(res => {
                pagination.total = res.data.total
                this.loading = false
                this.data = res.data.list
                this.pagination = pagination
            }).catch(() => {
                this.loading = false
            })
        },
        refresh() {
            this.getData()
        },
        search() {
            this.pagination.current = 1
            this.getData()
        },
        close() {
            this.$emit('update:showOnlinePage', false)
        },
        resetSearch() {
            this.queryParam = {}
            this.getData()
        },
        accessTo(route) {
            return this.$helper.accessTo('LoginDeviceController', route)
        },
        pageSizeChange(val, pageSize) {
            this.loading = true
            this.pagination.defaultPageSize = pageSize
            this.pagination.current = 1
        },
    }
}
